<template>

    <div class="custom-control custom-radio">
        <input
                :checked="modelValue == value"
                @change="updateInput"
                name="radio"
                :id="`customRadio${value}`"
                type="radio" class="custom-control-input">

        <em v-if="isRecommanded">Cure recommandée</em>

        <label class="custom-control-label" :for="`customRadio${value}`">
            <div class="descPrice">
                <strong>{{ name }}</strong>
                <small v-if="numberOfDays > 1 && numberOfDays !== null">({{ numberOfDays }} jours)</small>
                <small v-else-if="numberOfDays <= 1 && numberOfDays !== null">({{ numberOfDays }} jour)</small>
                <small v-else>&nbsp;</small>

                <span class="ref">Réf. {{ referenceCode }} | </span>
                <span v-if="!isUnavailable" class="stock">En stock</span>
                <span v-if="isUnavailable" class="out-of-stock">Bientôt disponible</span>
            </div>
            <span class="price">
                {{ price | moneyFormat }}
                <span class="promo" v-if="basePrice != price">
                    <del>{{ basePrice | moneyFormat }}</del> {{ advantageName }}
                </span>
            </span>
        </label>
    </div>

</template>

<script>

    import {mapActions, mapState} from 'vuex';
    import store from '../store';

    const CartReferenceCard = {
        name: 'ponroy-cart-reference-card',
        store,
        model: {
            prop: 'modelValue'
        },
        props: {
            name: {
                type: String,
                required: true
            },
            value: {
                type: String,
            },
            modelValue: {
                type: String,
            },
            isRecommanded: {
                type: Boolean,
            },
            numberOfDays: {
                type: Number,
            },
            referenceCode: {
                type: String,
            },
            isUnavailable: {
                type: Boolean,
            },
            price: {
                type: Number,
            },
            basePrice: {
                type: Number,
            },
            advantageName: {
                type: String,
            },
        },
        methods: {
            updateInput() {
                this.$emit('input', this.value)
            }
        }
    };

    export default CartReferenceCard;

</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartReferenceCard.vue